<template>
  <div class="legal-wrap" :class="isZh ? 'lang-cn' : 'lang-it'">
    <Head></Head>
    <div class="page">
      <div class="doc-header">
        <!-- 用户协议和隐私政策 -->
        <h1 class="doc-title doc-title-single">
          {{ $fanyi("用户协议和隐私政策") }}
        </h1>
        <div class="doc-sub">
          ADVANCING DIGITAL TRADE CO., LIMITED · www.rakumart.it
        </div>
      </div>

      <div class="info-card">
        <div class="info-row">
          <div class="info-label">
            <span class="it">Titolare del trattamento</span>
            <span class="cn">数据处理责任方</span>
          </div>
          <div class="info-value">ADVANCING DIGITAL TRADE CO., LIMITED</div>
        </div>
        <div class="info-row">
          <div class="info-label">
            <span class="it">E-mail di contatto</span>
            <span class="cn">联系邮箱</span>
          </div>
          <div class="info-value">
            <a href="mailto:service@rakumart.it">service@rakumart.it</a>
          </div>
        </div>
      </div>

      <div class="bi intro">
        <p class="it">
          Ai sensi della normativa in materia di protezione dei dati personali e
          dell'articolo 10 della Legge 34/2002 sui Servizi della Società
          dell'Informazione e del Commercio Elettronico, il proprietario del
          sito e responsabile del trattamento dei dati è ADVANCING DIGITAL TRADE
          CO., LIMITED.
        </p>
        <p class="cn">
          根据个人数据保护相关法规以及关于信息社会服务和电子商务的第 34/2002
          号法律第 10 条的规定，本网站的所有者及数据处理责任方为 ADVANCING DIGITAL TRADE
          CO., LIMITED。
        </p>
      </div>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">1</span>
          <span class="t">
            <span class="it">Uso e finalità dei dati raccolti</span>
            <span class="cn">收集数据的使用与目的</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            I dati richiesti sul nostro sito web sono adeguati, pertinenti e
            strettamente necessari per gestire e trattare la richiesta da Lei
            effettuata, inviarLe informazioni sui nostri servizi, nonché
            realizzare la compravendita di prodotti e servizi. In nessun caso
            Lei è obbligato a fornirli.
          </p>
          <p class="cn">
            我们网站上所要求的数据是适当、相关且严格必要的，仅用于管理和处理您提出的请求、向您发送我们服务的相关信息，以及完成产品和服务的买卖。您在任何情况下都没有义务提供这些数据。
          </p>
        </div>
        <div class="bi">
          <p class="it lead">Usi dei dati raccolti:</p>
          <p class="cn">所收集数据的用途：</p>
        </div>
        <ul class="bi-list">
          <li>
            <span class="it"
              >Gestire la richiesta effettuata tramite i nostri moduli di
              contatto.</span
            >
            <span class="cn">处理通过我们联系表单提出的请求。</span>
          </li>
          <li>
            <span class="it"
              >Inviare comunicazioni commerciali tramite SMS, WhatsApp ed
              e-mail.</span
            >
            <span class="cn">通过短信、WhatsApp 和电子邮件发送商业信息。</span>
          </li>
          <li>
            <span class="it"
              >Gestire l'acquisto di prodotti da parte del titolare dei
              dati.</span
            >
            <span class="cn">管理数据所有者的产品购买。</span>
          </li>
        </ul>
        <div class="bi">
          <p class="it">
            I dati contrassegnati come obbligatori sono indicati nel modulo
            stesso in cui vengono raccolti. Il mancato conferimento di tali dati
            comporterà l'impossibilità di gestire la Sua richiesta. Lei
            garantisce inoltre che tutti i dati forniti sono esatti, veritieri e
            pertinenti rispetto alla finalità per cui sono richiesti.
          </p>
          <p class="cn">
            标记为必填的数据已在收集数据的表单中注明。若不提供这些数据，将导致我们无法处理您的请求。您同时保证所提供的全部数据均真实、准确，并与我们收集数据的目的相关。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            I dati personali forniti saranno conservati per tutta la durata del
            rapporto commerciale e, una volta terminato tale rapporto, saranno
            mantenuti bloccati per il periodo legalmente previsto prima della
            loro cancellazione.
          </p>
          <p class="cn">
            您所提供的个人数据将在商业关系存续期间予以保存；在该关系结束后，将在法律规定的期限内被封存，之后予以删除。
          </p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">2</span>
          <span class="t">
            <span class="it">Base giuridica del trattamento</span>
            <span class="cn">数据处理的法律依据</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it lead">
            La base giuridica per il trattamento dei Suoi dati è costituita da:
          </p>
          <p class="cn">处理您数据的法律依据包括：</p>
        </div>
        <ul class="bi-list">
          <li>
            <span class="it"
              >Il consenso dell'interessato per la gestione e il trattamento
              delle richieste, nonché per l'invio di comunicazioni
              commerciali.</span
            >
            <span class="cn"
              >数据主体对请求的管理与处理，以及对发送商业信息所给予的同意。</span
            >
          </li>
          <li>
            <span class="it"
              >Il rapporto contrattuale necessario per la formalizzazione e la
              gestione della compravendita di prodotti.</span
            >
            <span class="cn">为正式订立和管理产品买卖所必需的合同关系。</span>
          </li>
        </ul>
        <div class="bi">
          <p class="it">
            L'invio dei dati implica la Sua autorizzazione espressa
            all'inserimento degli stessi nei nostri archivi, qualora ADVANCING DIGITAL TRADE
            CO., LIMITED lo ritenga opportuno per la gestione della
            richiesta effettuata.
          </p>
          <p class="cn">
            提交数据即表示您明确授权将这些数据纳入我们的档案，前提是 ADVANCING DIGITAL TRADE
            CO., LIMITED 认为这对处理您所提出的请求是适当的。
          </p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">3</span>
          <span class="t">
            <span class="it">Comunicazione e trasferimento dei dati</span>
            <span class="cn">数据的传达与转移</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            I Suoi dati non saranno ceduti a terzi senza il Suo consenso
            espresso, salvo le comunicazioni necessarie per adempiere a un
            obbligo di legge.
          </p>
          <p class="cn">
            未经您的明确同意，您的数据不会被转让给第三方，但为履行法律义务所必需的传达除外。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            La informiamo che i Suoi dati saranno trasferiti verso un Paese
            terzo al di fuori dello Spazio Economico Europeo, poiché l'acquisto
            dei prodotti viene effettuato presso aziende residenti nella
            Repubblica Popolare Cinese e i dati raccolti sul sito web sono
            conservati su un server installato nello stesso Paese. Tale
            trasferimento è necessario per la realizzazione della compravendita
            e per l'esecuzione del contratto.
          </p>
          <p class="cn">
            我们告知您，您的数据将被转移至欧洲经济区以外的第三国，因为产品采购是向居住在中华人民共和国的企业进行的，且在网站上收集的数据也保存在位于该国的服务器上。此项转移对于完成买卖及履行合同是必要的。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Con l'accettazione dell'apposita casella del modulo, Lei acconsente
            all'invio di informazioni relative ai nostri servizi che possano
            risultare di Suo interesse.
          </p>
          <p class="cn">
            通过勾选表单中的相应选项，您同意接收我们认为可能符合您兴趣的服务信息。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Per mantenere aggiornati i Suoi dati personali, è importante che ci
            informi di qualsiasi modifica. In caso contrario, non risponderemo
            della loro esattezza. Qualora Lei non richieda espressamente la
            cancellazione dei Suoi dati personali dai nostri archivi, riterremo
            che continui a essere interessato a rimanervi inserito fino a quando
            il Responsabile lo riterrà opportuno e fintanto che ciò risulti
            adeguato alla finalità per cui i dati sono stati raccolti.
          </p>
          <p class="cn">
            为保持您个人数据的更新，请您在数据发生任何变更时及时通知我们。否则，我们对其准确性不承担责任。若您未明确要求从我们的档案中删除您的个人数据，我们将视为您仍有意保留在档案中，直至责任方认为适当且数据仍符合其收集目的为止。
          </p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">4</span>
          <span class="t">
            <span class="it">Diritti degli interessati</span>
            <span class="cn">数据主体的权利</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it lead">Il titolare dei dati personali ha diritto a:</p>
          <p class="cn">个人数据所有者有权：</p>
        </div>
        <ul class="bi-list">
          <li>
            <span class="it"
              >Ottenere conferma che il Responsabile stia trattando o meno dati
              personali che lo riguardano.</span
            >
            <span class="cn"
              >获得有关责任方是否正在处理与其相关个人数据的确认。</span
            >
          </li>
          <li>
            <span class="it"
              >Accedere ai propri dati personali e richiedere la rettifica dei
              dati inesatti oppure, se del caso, la cancellazione quando, tra
              gli altri motivi, i dati non siano più necessari per le finalità
              per cui sono stati raccolti.</span
            >
            <span class="cn"
              >访问其个人数据，并要求更正不准确的数据；在数据不再为收集目的所必需等情形下，要求删除其数据。</span
            >
          </li>
          <li>
            <span class="it"
              >In determinate circostanze, richiedere la limitazione del
              trattamento dei propri dati; in tal caso il Responsabile li
              conserverà esclusivamente per l'esercizio o la difesa di eventuali
              reclami.</span
            >
            <span class="cn"
              >在特定情况下，要求限制对其数据的处理；此时责任方仅为行使或抗辩相关权利主张而保存这些数据。</span
            >
          </li>
          <li>
            <span class="it"
              >In determinate circostanze e per motivi legati alla propria
              situazione particolare, opporsi al trattamento dei propri
              dati.</span
            >
            <span class="cn"
              >在特定情况下并基于其特定处境的原因，反对对其数据的处理。</span
            >
          </li>
          <li>
            <span class="it"
              >In determinate circostanze, in virtù del diritto alla
              portabilità, ottenere i propri dati personali in un formato
              strutturato, di uso comune e leggibile da dispositivo automatico,
              e trasmetterli a un altro responsabile.</span
            >
            <span class="cn"
              >在特定情况下，依据可携权，以结构化、通用且机器可读的格式获取其个人数据，并将其传输给另一责任方。</span
            >
          </li>
        </ul>
        <div class="bi">
          <p class="it lead">Il titolare può esercitare i propri diritti:</p>
          <p class="cn">数据所有者可通过以下方式行使其权利：</p>
        </div>
        <ul class="bi-list">
          <li>
            <span class="it"
              >Mediante comunicazione scritta indirizzata a ADVANCING DIGITAL TRADE
              CO., LIMITED, Building 2, Floors 3-5, No.127 Chunhan Road, Beiyuan
              Sub-district, Yiwu City, Zhejiang Province, China, con riferimento
              "Protezione dei Dati".</span
            >
            <span class="cn"
              >以书面形式寄至 ADVANCING DIGITAL TRADE CO., LIMITED, Building 2,
              Floors 3-5, No.127 Chunhan Road, Beiyuan Sub-district, Yiwu City,
              Zhejiang Province, China，并注明 "数据保护" 字样。</span
            >
          </li>
          <li>
            <span class="it"
              >Mediante e-mail all'indirizzo service@rakumart.it, indicando
              nell'oggetto "Protezione dei Dati".</span
            >
            <span class="cn"
              >发送电子邮件至 service@rakumart.it，并在主题中注明
              "数据保护"。</span
            >
          </li>
        </ul>
        <div class="bi">
          <p class="it">
            Qualora ritenga che i Suoi diritti non siano stati adeguatamente
            rispettati, Lei ha il diritto di presentare un reclamo all'Agenzia
            Spagnola per la Protezione dei Dati.
          </p>
          <p class="cn">
            如您认为您的权利未得到妥善尊重，您有权向西班牙数据保护局提出投诉。
          </p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">5</span>
          <span class="t">
            <span class="it">Consenso all'uso dei cookie</span>
            <span class="cn">Cookie 使用同意</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            Per il corretto funzionamento del nostro sito web utilizziamo i
            cookie. Per ottenere un consenso valido all'uso e alla conservazione
            dei cookie nel browser utilizzato per accedere al nostro sito web, e
            per documentarlo correttamente, utilizziamo una piattaforma di
            gestione del consenso: CookieFirst. Questa tecnologia è fornita da
            Digital Data Solutions BV, Plantage Middenlaan 42a, 1018 DH
            Amsterdam, Paesi Bassi. Sito web:
            <a href="https://cookiefirst.com" target="_blank" rel="noopener"
              >https://cookiefirst.com</a
            >, denominata CookieFirst.
          </p>
          <p class="cn">
            为使我们的网站正常运行，我们使用
            Cookie。为获得您在用于访问我们网站的浏览器中使用和存储 Cookie
            的有效同意，并对其进行妥善记录，我们使用了一个同意管理平台：CookieFirst。该技术由
            Digital Data Solutions BV 提供，地址为 Plantage Middenlaan 42a, 1018
            DH Amsterdam，荷兰。网站：https://cookiefirst.com，称为
            CookieFirst。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Quando Lei accede al nostro sito web, viene stabilita una
            connessione con il server di CookieFirst al fine di consentirci di
            ottenere il Suo consenso valido per l'uso di determinati cookie.
            Successivamente, CookieFirst memorizza un cookie nel Suo browser per
            attivare solo i cookie per i quali Lei ha prestato il consenso e per
            documentare correttamente tale consenso.
          </p>
          <p class="cn">
            当您访问我们的网站时，会与 CookieFirst
            服务器建立连接，以便我们获得您对使用某些 Cookie
            的有效同意。随后，CookieFirst 会在您的浏览器中存储一个
            Cookie，以便仅激活您已同意的 Cookie 并妥善记录该同意。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            I dati trattati sono conservati fino alla scadenza del periodo di
            conservazione predefinito oppure fino a quando Lei richiede la
            cancellazione dei dati. Restano salvi eventuali periodi di
            conservazione obbligatori previsti dalla legge.
          </p>
          <p class="cn">
            所处理的数据将保存至预定的保存期限届满，或直至您要求删除数据为止。法律规定的强制性保存期限不受影响。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            CookieFirst viene utilizzato per ottenere il consenso legalmente
            richiesto per l'uso dei cookie. La base giuridica è l'articolo 6,
            paragrafo 1, lettera c) del Regolamento Generale sulla Protezione
            dei Dati (GDPR).
          </p>
          <p class="cn">
            CookieFirst 用于获得法律所要求的 Cookie
            使用同意。其法律依据为《通用数据保护条例》(GDPR) 第 6 条第 1 款 (c)
            项。
          </p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">6</span>
          <span class="t">
            <span class="it">Accordo per il trattamento dei dati</span>
            <span class="cn">数据处理协议</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            Abbiamo concluso un accordo per il trattamento dei dati con
            CookieFirst. Si tratta di un contratto richiesto dalla normativa in
            materia di protezione dei dati, che garantisce che i dati dei
            visitatori del nostro sito web siano trattati esclusivamente secondo
            le nostre istruzioni e nel rispetto del GDPR.
          </p>
          <p class="cn">
            我们已与 CookieFirst
            签订数据处理协议。这是数据保护法规所要求的合同，确保我们网站访客的数据仅按照我们的指示并遵守
            GDPR 进行处理。
          </p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">7</span>
          <span class="t">
            <span class="it">File di registro del server</span>
            <span class="cn">服务器日志文件</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            Il nostro sito web e CookieFirst raccolgono e conservano
            automaticamente informazioni nei cosiddetti file di registro del
            server.
          </p>
          <p class="cn">
            我们的网站和 CookieFirst
            会自动在所谓的服务器日志文件中收集并保存信息。
          </p>
        </div>
      </section>
    </div>
    <Foot style="width: 100%"></Foot>
  </div>
</template>
<script>
import Head from "../../components/head/HomePageTop.vue";
import Foot from "@/components/foot/Foot.vue";
export default {
  data() {
    return {};
  },
  components: { Head, Foot },
  computed: {
    isZh() {
      return !!this.$store.state.fanyi;
    },
  },
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";

$accent: #009246;

.legal-wrap {
  background: #f4f6f9;
  padding: 0 0 60px;

  &.lang-it .cn {
    display: none !important;
  }

  &.lang-cn .it {
    display: none !important;
  }
}

.page {
  width: 900px;
  margin: 30px auto 60px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 8px 30px rgba(20, 30, 60, 0.07);
  padding: 50px 60px 56px;
}

.doc-header {
  text-align: center;
  padding-bottom: 26px;
  border-bottom: 2px solid #f0f2f5;
  margin-bottom: 34px;

  .doc-title {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;

    &.doc-title-single {
      display: block;
      font-size: 30px;
      font-weight: 700;
      color: #1d2129;
      line-height: 1.2;
      text-align: center;
    }

    .it {
      font-size: 30px;
      font-weight: 700;
      color: #1d2129;
      line-height: 1.2;
    }

    .cn {
      font-size: 17px;
      font-weight: 500;
      color: #86909c;
      letter-spacing: 2px;
    }
  }

  .doc-sub {
    margin-top: 14px;
    font-size: 13px;
    color: #a0a8b5;
    letter-spacing: 0.5px;
  }
}

.info-card {
  background: linear-gradient(135deg, #f0faf4 0%, #fff 100%);
  border: 1px solid #c8e6c9;
  border-radius: 10px;
  padding: 18px 24px;
  margin-bottom: 34px;

  .info-row {
    display: flex;
    align-items: center;
    padding: 8px 0;

    & + .info-row {
      border-top: 1px dashed #d4edda;
    }

    .info-label {
      flex: 0 0 220px;
      display: flex;
      flex-direction: column;

      .it {
        font-size: 14px;
        font-weight: 600;
        color: #4e5969;
      }

      .cn {
        font-size: 12px;
        color: #a0a8b5;
      }
    }

    .info-value {
      font-size: 14px;
      color: #1d2129;
      font-weight: 500;

      a {
        color: $accent;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}

.sec {
  margin-bottom: 36px;

  .sec-title {
    display: flex;
    align-items: center;
    margin-bottom: 18px;

    .num {
      flex: 0 0 34px;
      height: 34px;
      line-height: 34px;
      text-align: center;
      border-radius: 9px;
      background: $accent;
      color: #fff;
      font-size: 16px;
      font-weight: 700;
      margin-right: 14px;
    }

    .t {
      display: flex;
      flex-direction: column;

      .it {
        font-size: 18px;
        font-weight: 700;
        color: #1d2129;
        line-height: 1.3;
      }

      .cn {
        font-size: 13px;
        color: #86909c;
      }
    }
  }
}

.bi {
  margin-bottom: 16px;

  &.intro {
    background: #f7f8fa;
    border-radius: 10px;
    padding: 18px 22px;
    margin-bottom: 32px;
  }

  .it {
    font-size: 14.5px;
    line-height: 1.75;
    color: #2b303a;
    margin-bottom: 6px;

    &.lead {
      font-weight: 600;
    }

    a {
      color: $accent;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .cn {
    font-size: 13.5px;
    line-height: 1.75;
    color: #86909c;
  }
}

.bi-list {
  margin: 0 0 18px;
  padding: 0;

  li {
    position: relative;
    list-style: none;
    padding: 10px 16px 10px 30px;
    border-radius: 8px;
    margin-bottom: 8px;
    background: #f7f8fa;

    &::before {
      content: "";
      position: absolute;
      left: 14px;
      top: 19px;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: $accent;
    }

    .it {
      display: block;
      font-size: 14px;
      line-height: 1.7;
      color: #2b303a;
    }

    .cn {
      display: block;
      font-size: 13px;
      line-height: 1.7;
      color: #86909c;
      margin-top: 2px;
    }
  }
}
</style>
